export default __webpack_public_path__ + "static/media/home1.86768aa7.png";